//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import pick from 'lodash.pick';
import { addDict, editDict, duplicateCheck } from '@/api/api';
export default {
  name: 'DictModal',
  data: function data() {
    return {
      value: 1,
      title: '操作',
      visible: false,
      model: {},
      labelCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 5
        }
      },
      wrapperCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 16
        }
      },
      confirmLoading: false,
      form: this.$form.createForm(this),
      validatorRules: {
        dictName: {
          rules: [{
            required: true,
            message: '请输入字典名称!'
          }]
        },
        dictCode: {
          rules: [{
            required: true,
            message: '请输入字典编码!'
          }, {
            validator: this.validateDictCode
          }]
        }
      }
    };
  },
  created: function created() {},
  methods: {
    validateDictCode: function validateDictCode(rule, value, callback) {
      // 重复校验
      var params = {
        tableName: 'sys_dict',
        fieldName: 'dict_code',
        fieldVal: value,
        dataId: this.model.id
      };
      duplicateCheck(params).then(function (res) {
        if (res.success) {
          callback();
        } else {
          callback(res.message);
        }
      });
    },
    handleChange: function handleChange(value) {
      this.model.status = value;
    },
    add: function add() {
      this.edit({});
    },
    edit: function edit(record) {
      var _this = this;

      if (record.id) {
        this.visiblekey = true;
      } else {
        this.visiblekey = false;
      }

      this.form.resetFields();
      this.model = Object.assign({}, record);
      this.visible = true;
      this.$nextTick(function () {
        _this.form.setFieldsValue(pick(_this.model, 'dictName', 'dictCode', 'description'));
      });
    },
    // 确定
    handleOk: function handleOk() {
      var _this2 = this;

      var that = this; // 触发表单验证

      this.form.validateFields(function (err, values) {
        if (!err) {
          that.confirmLoading = true;
          values.dictName = (values.dictName || '').trim();
          values.dictCode = (values.dictCode || '').trim();
          values.description = (values.description || '').trim();
          var formData = Object.assign(_this2.model, values);
          var obj;
          console.log(formData);

          if (!_this2.model.id) {
            obj = addDict(formData);
          } else {
            obj = editDict(formData);
          }

          obj.then(function (res) {
            if (res.success) {
              that.$notification.success({
                message: res.message
              });
              that.$emit('ok');
              that.close();
            } else {
              that.$notification.warning({
                message: res.message
              });
            }
          }).finally(function () {
            that.confirmLoading = false;
          });
        }
      });
    },
    // 关闭
    handleCancel: function handleCancel() {
      this.close();
    },
    close: function close() {
      this.$emit('close');
      this.visible = false;
    }
  }
};